// extracted by mini-css-extract-plugin
export default {"avatarUsu":"AvatarUsuarioLog_avatarUsu__P2K4y"};